export const SUPER_ADMIN = 'SuperAdmin';
export const ADMINISTRATION = 'Administration';
export const AUTHOR = 'Author';
// export const REVIEWER = 'Reviewer';
export const MOBILE = 'Mobile';

export const ROLE_LIST = [
  SUPER_ADMIN,
  ADMINISTRATION,
  AUTHOR,
  // REVIEWER,
  MOBILE,
] as const;

export const COMPANY_ROLE_LIST = [
  ADMINISTRATION,
  AUTHOR,
  // REVIEWER,
  MOBILE,
] as const;

type RolesMapping = {
  [key: string]: string;
};

export const ROLES_MAPPING: RolesMapping = {
  [SUPER_ADMIN]: 'roles.super_admin',
  [ADMINISTRATION]: 'roles.administration',
  [AUTHOR]: 'roles.author',
  // [REVIEWER]: 'roles.reviewer',
  [MOBILE]: 'roles.mobile',
};

// Default landing route per role, used after login to navigate straight to the
// role's home page instead of relying on the router's `/` index redirect (which
// races the role-driven router rebuild — see Login.tsx / DLA-1502).
export const ROLE_HOME_PATH: RolesMapping = {
  [SUPER_ADMIN]: '/companies',
  [ADMINISTRATION]: '/facilities',
  [AUTHOR]: '/facilities',
  // [REVIEWER]: '/facilities',
  [MOBILE]: '/settings/profile',
};

/**
 * @description Resolves the post-login landing route for a user's role.
 * Falls back to '/' for an unknown or absent role.
 *
 * @param {string | null | undefined} role - The user's role string.
 * @returns {string} The route to navigate to after login.
 */
export const getRoleHomePath = (role?: string | null): string =>
  role && Object.prototype.hasOwnProperty.call(ROLE_HOME_PATH, role)
    ? ROLE_HOME_PATH[role]
    : '/';
